<div class="row demographics">
    <div class="col-xs-12 col-sm-6">
        <div class="card card-block card--box card--box--dashboard card--box--dashboard__item">
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'Gender distribution' | translate }}
                </h2>
            </div>
            <ng-container *ngIf="gendersData; else noDataGenders">
                <div class="card card--box--dashboard__item__block mr-t--md">
                    <div *ngFor="let gender of gendersData" class="row d-flex mr-t--xs">
                        <div class="col-xs-3 d-flex demographics__label">
                            <span>
                                {{ gender['name'] | translate}}
                            </span>
                        </div>
                        <div class="col-xs-8 d-flex demographics__chart">
                            <div class="demographics__chart__bar">
                                <span class="demographics__chart__bar__item low"
                                      tooltip="{{gender['total']}} {{ gender['name'] | translate}}"
                                      style.width="{{gender['percent']}}%"></span>
                            </div>
                        </div>
                        <div class="col-xs-1 d-flex demographics__chart">
                            <div class="demographics__chart__percent">
                                <span class="">{{gender['percent']}}% </span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noDataGenders>
                <div class="card card--box--dashboard__item__block mental-check mr-t--md text-center">
                    {{ message | translate}}
                </div>
            </ng-template>


            <!-- Age Distribution -->
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'Age distribution' | translate }}
                </h2>
            </div>
            <ng-container *ngIf="agesData; else noDataAges">
                <div class="card card--box--dashboard__item__block mr-t--md">
                    <div class="row d-flex demographics mr-t--xs">
                        <div class="col-xs-12 d-flex demographics__chart">
                            <div class="demographics__chart__bar">
                                <span class="demographics__chart__bar__item age" style="width: 100%"></span>
                            </div>
                        </div>
                    </div>
                    <div class="row mr-t--sm label">
                        <div class="col-xs-4">
                            18 {{ 'Years' | translate}}
                        </div>
                        <div class="col-xs-4 text-center age-average">
                            Ø {{ agesData['average']}} {{ 'Years' | translate}}
                        </div>
                        <div class="col-xs-4 text-right">
                            90 {{ 'Years' | translate}}
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noDataAges>
                <div class="card card--box--dashboard__item__block mental-check mr-t--md text-center">
                    {{ message | translate}}
                </div>
            </ng-template>
        </div>

    </div>

    <div class="col-xs-12 col-sm-6 padding-xs">
        <div class="card card-block card--box card--box--dashboard card--box--dashboard__item">
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'Languages' | translate }}
                </h2>
            </div>
            <ng-container *ngIf="languagesData; else noDataLanguages">
                <div class="card card--box--dashboard__item__block mr-t--md">
                    <div *ngFor="let lang of languagesData" class="row d-flex demographics mr-t--xs">
                        <div class="col-xs-3 d-flex demographics__label">
                            <span>
                                {{ lang['name'] | translate}}
                            </span>
                        </div>
                        <div class="col-xs-8 d-flex demographics__chart">
                            <div class="demographics__chart__bar">
                                <span class="demographics__chart__bar__item low"
                                      tooltip="{{lang['total']}} {{ lang['name'] | translate}}"
                                      style.width="{{lang['percent']}}%"></span>
                            </div>
                        </div>
                        <div class="col-xs-1 d-flex demographics__chart">
                            <div class="demographics__chart__percent">
                                <span class="">{{lang['percent']}}% </span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noDataLanguages>
                <div class="card card--box--dashboard__item__block mental-check mr-t--md text-center">
                    {{ message | translate}}
                </div>
            </ng-template>
        </div>
    </div>
</div>